import React, { useEffect, useState } from "react";
import "./product.css";
import Footer from "../footer/footer";
import axios from "axios";
import Papa from "papaparse";

const SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSc70Ejn0hI5yncbLvE0gY0fABMhIGHrSApsiD1GpBzSHInedtjlvoGzgQl5pLP9Q0dx8ngeoPA5BnO/pub?output=csv"; // 🔁 Replace with your published CSV URL

const ProductCertificate = () => {
  const [products, setProducts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    const fetchSheetData = async () => {
      try {
        const response = await axios.get(SHEET_URL);
        const parsed = Papa.parse(response.data, { header: true }).data;
        // Clean + normalize
        const cleaned = parsed.map((item, index) => ({
          id: item.id || index,
          name: item.name?.trim() || "Unnamed Product",
          image: item.image?.trim() || "./files/default.jpg",
          description: item.description?.trim() || "No description available.",
          inStock:
            item.inStock?.toString().toLowerCase().trim() === "true" ||
            item.inStock?.toString().toLowerCase().trim() === "yes",
        }));
        setProducts(cleaned);
      } catch (error) {
        console.error("Error fetching Google Sheet data:", error);
      }
    };

    fetchSheetData();
  }, []);

  return (
    <>
      <div className="product-certificate-page">
        <div className="product-certificate-section">
          <h2 className="section-title underline-title">Our Products</h2>

          <div className="product-grid">
            {products.map((item) => (
              <div
                key={item.id}
                className={`product-card ${!item.inStock ? "disabled" : ""}`}
                onClick={() => {
                  if (!item.inStock) return;
                  setSelectedImage(item.image);
                  setSelectedProduct(item);
                }}
              >
                {!item.inStock && (
                  <span className="out-of-stock">Out of Stock</span>
                )}
                <img src={item.image} alt={item.name} className="product-img" />
                <p className="product-name">{item.name}</p>
              </div>
            ))}
          </div>

          {/* ===== Modal ===== */}
          {selectedImage && selectedProduct && (
            <div
              className="custom-modal-overlay"
              onClick={() => {
                setSelectedImage(null);
                setSelectedProduct(null);
              }}
            >
              <div
                className="custom-modal image-modal-box"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="close-btn"
                  onClick={() => {
                    setSelectedImage(null);
                    setSelectedProduct(null);
                  }}
                >
                  ✕
                </button>

                <div className="modal-content-wrapper">
                  <img
                    src={selectedImage}
                    alt={selectedProduct.name}
                    className="modal-image"
                  />
                  <div className="modal-description">
                    <h3 className="modal-product-title">
                      {selectedProduct.name}
                    </h3>
                    <p className="modal-product-text">
                      {selectedProduct.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ProductCertificate;
